/*
 * @Descripttion: vue自定义指令存放
 * @version: 1.0
 * @Author: 任治宁
 * @Date: 2020-07-20 09:29:51
 * @LastEditors: 任治宁
 * @LastEditTime: 2020-07-21 18:41:18
 */

import Vue from 'vue'

//验证输入框：如果输入不匹配正则，则变更为上一次的值
Vue.directive('inputLimit', {
  componentUpdated (el, binding, vnode,oldVnode) {
    const reg = binding.value  // 正则参数
    const data = vnode.data.model.value
    const olddata = oldVnode.data.model.value
    if(!reg.test(data)){
      vnode.data.model.callback(olddata)
    }
  }
})
